import { Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../base.component';
import { MatDialogRef } from '@angular/material';
import { ExportPdfModalData } from '../../../components/hub/export.pdf.modal/export.pdf.modal.provider';
import { ShowMoreEventTimesModalActions, ShowMoreEventTimesModalData } from './show.more.event.times.modal.provider';

@Component({
    templateUrl: './show.more.event.times.modal.component.html',
    styleUrls: ['./show.more.event.times.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ShowMoreEventTimesModalComponent extends BaseComponent {

    public data: ShowMoreEventTimesModalData;
    public hubName: string;

    constructor(private dialogRef: MatDialogRef<ShowMoreEventTimesModalComponent>,
                private actions: ShowMoreEventTimesModalActions,
                data: ShowMoreEventTimesModalData) {
        super();
        this.data = Object.assign({}, data);
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public confirm() {
        this.actions.confirm();
        this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/show.more.event.times.modal/show.more.event.times.modal.component.ts